const Footer = () => {
    const today = new Date();
    return (
        <footer>
            <small>
                Copyright &copy; {today.getFullYear()}, Logan Scheid, All Rights
                Reserved
            </small>
        </footer>
    );
};

export default Footer;
